import { render, staticRenderFns } from "./DiscussionItem.vue?vue&type=template&id=2a71cdf4"
import script from "./DiscussionItem.vue?vue&type=script&lang=js"
export * from "./DiscussionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a71cdf4')) {
      api.createRecord('2a71cdf4', component.options)
    } else {
      api.reload('2a71cdf4', component.options)
    }
    module.hot.accept("./DiscussionItem.vue?vue&type=template&id=2a71cdf4", function () {
      api.rerender('2a71cdf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/DiscussionItem.vue"
export default component.exports